import React from 'react';
import { VideoAd } from '../../models';
import { Button, Checkbox, TableCell, TableRow, Tooltip } from '@mui/material';
import GppMaybeIcon from "@mui/icons-material/GppMaybe";
import { useCurrentUser } from '../../hooks/useCurrentUser';
import { Link } from 'react-router-dom';

interface VideoAdTableRowProps {
  videoAd: VideoAd
  dark: boolean,
  selected: boolean,
  onVideoAdSelect?: (videoAd: VideoAd) => void
}

export const VideoAdTableRow: React.FC<VideoAdTableRowProps> = ({
  videoAd,
  dark,
  selected,
  onVideoAdSelect,
}) => {
  const user = useCurrentUser()

  return (
    <TableRow className={dark ? 'dark_row' : 'light_row'}>
      {videoAd.status === "src_issue" && (
        <div className="src-warning">
          <Tooltip title={"Source Error"}><GppMaybeIcon color="error" /></Tooltip>
        </div>
      )}
      <TableCell style={{ padding: "0.25rem 1.25rem" }}>
        <Checkbox className="table_cell" checked={selected} onChange={() => onVideoAdSelect?.(videoAd)}></Checkbox>
      </TableCell>
      <TableCell className="table_cell">
        <div className="hover-image" title={videoAd.title}>
          {videoAd.title}
          {videoAd.contentUrl ? (
            <div className="image-tooltip video-container">
              <video muted autoPlay style={{ width: "100%", height: "100%" }}>
                <source src={videoAd.contentUrl} type="video/mp4" />
              </video>
            </div>
          ) : (
            <div className="image-tooltip"></div>
          )}
        </div>
      </TableCell>
      <TableCell className="table_cell">
        {new Date(videoAd.createdAt).getDate()}/{new Date(videoAd.createdAt).getMonth()+1}/{new Date(videoAd.createdAt).getFullYear()}
      </TableCell>
      <TableCell>
        <div style={{ justifyContent: "space-between", display: "flex" }}>
          <Button component={Link} to={!user?.perms.p2 ? `/content/new-video-ads` : `/content/new-video-ads/${videoAd.id}`} disabled={!user?.perms.p2} size="small" variant="contained" color="secondary">
            Edit
          </Button>
        </div>
      </TableCell>
    </TableRow>
  );
};